(() => {
  let returnFocus;
  let pending = false;
  const root = window.Shopify?.routes?.root || '/';
  const drawer = () => document.querySelector('[data-cinta-cart]');
  const open = () => {
    const dialog = drawer();
    if (!dialog || dialog.open) return;
    returnFocus = document.activeElement;
    dialog.showModal();
    dialog.querySelector('[data-cart-close]')?.focus();
  };
  const close = () => {
    drawer()?.close();
    if (returnFocus?.isConnected) returnFocus.focus();
  };
  const showError = message => {
    const target = drawer()?.querySelector('[data-cart-error]');
    if (target) { target.textContent = message; target.hidden = false; }
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('#shopify-section-cinta-cart-drawer');
    const current = document.querySelector('#shopify-section-cinta-cart-drawer');
    if (!next || !current) throw new Error('Your cart could not be displayed. Please try again.');
    current.replaceWith(next);
    const count = Number(drawer().dataset.cartCount);
    const cartLink = document.querySelector('.kr-cart');
    if (cartLink) {
      let badge = cartLink.querySelector('.kr-cart-count');
      if (count && !badge) { badge = document.createElement('span'); badge.className = 'kr-cart-count'; cartLink.append(badge); }
      if (badge) { badge.textContent = String(count); badge.hidden = !count; }
    }
    open();
  };
  const refresh = async () => {
    const response = await fetch(`${root}?section_id=cinta-cart-drawer`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Your cart could not be loaded. Please try again.');
    render(await response.text());
  };
  document.addEventListener('click', async event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-cart-close]')) { close(); return; }
    if (target === drawer()) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      return;
    }
    const quantity = target.closest('[data-cart-quantity]');
    if (quantity) {
      if (pending) return;
      event.preventDefault();
      pending = true;
      drawer().setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${root}cart/change.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: quantity.dataset.cartKey, quantity: Number(quantity.dataset.cartQuantity), sections: ['cinta-cart-drawer'], sections_url: window.location.pathname }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the quantity.');
        if (data.sections?.['cinta-cart-drawer']) render(data.sections['cinta-cart-drawer']);
        else await refresh();
      } catch (error) { showError(error.message); }
      finally { pending = false; drawer()?.removeAttribute('aria-busy'); }
      return;
    }
    const link = target.closest('a[href]');
    if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === `${root}cart`.replace(/\/$/, '')) {
        event.preventDefault();
        open();
        try { await refresh(); } catch (error) { showError(error.message); }
      }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-ref-product]') || !form.querySelector('[data-ref-submit]') || !drawer()) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    const button = form.querySelector('[data-ref-submit]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const body = new FormData(form);
      body.set('sections', 'cinta-cart-drawer');
      body.set('sections_url', window.location.pathname);
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item to your cart.');
      if (data.sections?.['cinta-cart-drawer']) render(data.sections['cinta-cart-drawer']);
      else await refresh();
    } catch (error) { open(); showError(error.message); }
    finally { pending = false; button.disabled = false; button.removeAttribute('aria-busy'); }
  });
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-cinta-cart]') && returnFocus?.isConnected) returnFocus.focus();
  }, true);
})();

